import  {
  useCallback,
    useEffect,
    
    useRef,
    
    useState,
  } from 'react';
  import { useTranslation } from 'react-multi-lang';
  
  // Redux
  import { useDispatch, useSelector } from 'react-redux';
  import { companySlice,initailState } from './CompanySlice';


  // API
  import { company}from '../../services/api/api';
  
  // Components
  import TableActionBar from '../../components/TableActionBar/TableActionBar';

  import { EllipsisLoader, WhiteboxLoader } from '../../components/Loader/Loader';
  import { Confirm } from '../../components/Alerts/Alerts';
  import { havePermission } from '../../services/hoc/permissions';
  import {  useLocation, useNavigate } from 'react-router-dom';
  import { useNotification } from '../../services/usenotification';
  import { Tooltip } from '@mui/material';
import { SortTable } from '../../components/Table/SortTable';

import { useAPI } from '../../services/hoc/useAPI';
import { AxiosError } from 'axios';
  
  export default () => {
    // Translation
    const t = useTranslation();
    const [pagesInfo, setPagesInfo] = useState({ page: 1, lastPage: 1 });
 
    // Redux
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { alertError500 } = useNotification();
  const keyword_ref = useRef<string|null>(null)
    const state = useSelector((state: { company: initailState }) => state.company);
    const [openOrderDetail, setOpenOrderDetail] = useState(false);
  
    // Hooks
    
  const ENDPOINTS = useAPI()
  
    // Search
    const search = (value: string) => {
      
      dispatch(companySlice.actions.reset());
       keyword_ref.current=Boolean(value)?value:null
      fetchData(1,Boolean(value)? 20:8, value);
    };
  
    // Fetch Data
    const fetchData =useCallback ((
      page_number:number,
      page_size: number = 10,
      keyword?: string,
    ) => {
      dispatch(companySlice.actions.setIsFetching(true));
  keyword=Boolean(keyword)?keyword:keyword_ref.current?keyword_ref.current:''
      ENDPOINTS.company()
        .show({ id:1 })
        .then((response: any) => {
          dispatch(companySlice.actions.setIsFetching(false));
        
          if (response.data.data.last_page)
            setPagesInfo((pre) => ({
              ...pre,
              lastPage: response.data.data.last_page,
            }));
          let company: company = response.data.data
  

          //dispatch(ordersSlice.actions.reset());
  
          dispatch(companySlice.actions.addCompany(company));
        
          if (!state.isLoaded) dispatch(companySlice.actions.setIsLoaded(true));
        })
        .catch((err:AxiosError)=>{
          alertError500(err)
          dispatch(companySlice.actions.setIsFetching(false));

        })
    },[dispatch,ENDPOINTS,state.isLoaded]
)
  
    interface tableDataType {
      [key: string]: any;
    }

    const generateData: () => tableDataType = () => {
     let data:tableDataType[]=[]
     // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      state
        ? 
            data[0] = {
              
              name: state.company?.name,
             date : state.company?.updated_at,
            address:state.company?.address,
              commercial_name: state.company?.commercial_name,
             email:state.company?.email,
             description:state.company?.description,
  
              actions: (
                <div className="show-on-hover">
                  {havePermission('Show Order') &&
                  havePermission('Edit Order') ? (
                    <>
                      <Tooltip title={t('info')}>
                        <i
                          className="icon-info"
                          onClick={() => {
                            setOpenOrderDetail(true);
                        
                            navigate(`/company-info/${state.company?.id}`);
                          }}
                        />
                      </Tooltip>
                    </>
                  ) : (
                    ''
                  )}
  
                  {/* {havePermission('Delete Order') ? (
                    <Tooltip title={t('delete')}>
                      <i
                        className="icon-delete"
                        data-tip={t('delete-order')}
                        onClick={(e: React.MouseEvent<HTMLLIElement>) => {
                          e.stopPropagation();
                          Confirm({
                            message: t('delete_confirmation'),
                            onConfirm: () => deleteCompany(state.company?.id?state.company.id:0),
                          });
                        }}
                      />
                    </Tooltip>
                  ) : (
                    ''
                  )} */}
                </div>
              ),
            }
        : null;
  
      return data;
    };
  
    // Toggle Selected id
    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const toggleSelectedId = (id: number) => {
      if (!havePermission('Delete Order')) return;
      let index = selectedIds.findIndex((selectedId) => selectedId === id);
      if (index !== -1) {
        setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
      } else setSelectedIds([...selectedIds, id]);
    };
  
    // Delete
    const remove = (id?: number) => {
      let ids = id ? [id] : selectedIds.map((x) => +x);
      dispatch(companySlice.actions.setIsLoading(true));
      ENDPOINTS.orders()
        .delete({ ids })
        .then(() => {
          setSelectedIds([]);
          dispatch(companySlice.actions.setIsLoading(false));
          dispatch(companySlice.actions.deleteCompany(ids));
        });
    };
  
    useEffect(() => {
      if (location.state) {
        if (!state.isFetching) {
          search(location.state.key);
        }
      } else {
        if (!state.isLoaded && !state.isFetching) {
          fetchData(1);
        }
      }
    }, [location.state]);

    useEffect(()=>{
      if (!state.isFetching) {
            
               fetchData(1);
             }
    },[])
    // useEffect(() => {
    //   if (pagesInfo && pagesInfo.page !== state.page) {
    //     if (!state.isFetching) {
    //       ordersSlice.actions.setPage(pagesInfo.page);
    //       fetchData(pagesInfo.page);
    //     }
    //   }
    // }, [pagesInfo]);
  
   
  
    return (
      <>
        {state.isLoaded ? (
          <>
            {state.isLoading ? <WhiteboxLoader /> : ''}
            <TableActionBar
              keyword={location.state ? location.state.key : ''}
              title={t('company_info')}
              search={search}
              showFilter={false}
              showDelete={selectedIds.length > 0}
              delete={() => {
                Confirm({
                  message: t('delete_confirmation'),
                  onConfirm: () => remove(),
                });
              }}
              addText={t('add_to_orders')}
              add={
               
                   undefined
              }
            />
  
            {/* <DashboardTable
          
              header={[
                t('name'),
                t('date'),
                t('address'),
                t('commercial_name'),
                t('email'),
                t('description'),
                '',
              ]}
              body={generateData()}
              onSelect={toggleSelectedId}
              hasMore={false}
              loadMore={fetchData}
              pagesInfo={pagesInfo}
              setPagesInfo={setPagesInfo}
             noPagination={true}
            /> */}
            <SortTable 
                header={[
                  t('name'),
                  t('date'),
                  t('address'),
                  t('commercial_name'),
                  t('email'),
                  t('description'),
                  '',
                ]}
                state={state.company?[state.company]:[]}
                onSelect={toggleSelectedId}
                hasMore={false}
                loadMore={fetchData}
                pagesInfo={pagesInfo}
                setPagesInfo={setPagesInfo}
              noPagination={true}
          >
            <>
            {
              generateData()
            }
            </>
          </SortTable>
  
            {/* <OrderDetail
              open={openOrderDetail}
              setOpen={setOpenOrderDetail}
              data={generateOrderDetail()}
            /> */}
            {/* <AddModal />
            <ShowSupplier /> */}
  
            
          </>
        ) : (
          <div className="center">
            <EllipsisLoader />
          </div>
        )}
      </>
    );
  };
  